
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 159 203","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{staticClass:"inner",attrs:{"fill":"#FFF","d":"M31.195 95.441l35.297 59.306V203h93.05V33.032H49.511z"}}),_c('path',{staticClass:"outer",attrs:{"d":"M101.383 0C79.273 0 73.88 0 67.66 1.216 61.44 2.43 54.676 4.923 48.518 7.845 31.158 16.08 18.19 28.82 9.573 45.843 5.036 54.805 2.129 64.378.81 74.416c-1.506 11.47-.89 22.716 2.642 33.775 5.845 18.298 17.511 32.073 33.702 41.924 15.2 9.247 31.716 12.737 49.296 8.243 17.973-4.594 30.755-15.554 37.896-32.638 4.657-11.143 4.894-22.745 1.422-34.277-3.781-12.557-11.403-22.154-23.547-27.524-10.644-4.706-21.43-5.07-31.752 1.148-6.163 3.713-9.769 9.27-11.347 16.323-3.399 15.184 8.032 30.361 24.527 30.822 3.1.087 6.012-.644 8.926-1.453 1.258-.35 1.506.074 1.51 1.215.014 3.183-1.456 5.752-3.553 7.887-6.18 6.291-13.935 7.251-22.055 5.564-8.209-1.705-15.253-5.656-20.852-12.126-4.312-4.983-7.36-10.407-8.831-16.908-1.04-4.599-1.158-9.155-.998-13.754.336-9.718 3.575-18.52 9.395-26.247 5.517-7.324 12.697-12.49 21.437-15.6 8.502-3.024 17.194-4.632 26.162-3.864 10.98.941 20.863 4.97 29.909 11.297 8.498 5.943 15.938 12.87 21.54 21.616 6.064 9.465 9.133 19.943 10.458 31.05 1.448 12.135.504 24.01-3.035 35.698-4.105 13.56-11.188 25.379-20.848 35.708-8.266 8.839-18.003 15.676-28.923 20.788-9.177 4.296-18.916 6.943-28.825 8.977-1.93.365-4.552.747-8.574.94.838.022 4.394.022 10.67 0h82.38c-.144 0-.144-67.667 0-203h-58.16z","fill":"#06396B"}})])])
          )
        }
      }
    